module.exports = __webpack_public_path__ + "media/images/application/logo-4dc32bc7efdef9a32135406aba290cae.svg";